.mf-proactive-case-closure {
  display: block;
}

.mf-proactive-case-closure__container {
  max-width: 700px;
  margin: 0 auto;
}

.mf-proactive-case-closure fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}

.mf-proactive-case-closure__radio-buttons-container {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
}

.mf-proactive-case-closure__radio-buttons-container::before,
.mf-proactive-case-closure__radio-buttons-container::after {
  content: "";
  display: block;
  flex-grow: 1;
}

.mf-proactive-case-closure__radio-buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
}

@media (min-width: 512px) {
  ux-modal-content .mf-proactive-case-closure {
    margin: 0 60px;
  }

  .mf-proactive-case-closure__radio-buttons-container {
    flex-direction: column;
  }

  .mf-proactive-case-closure__radio-buttons {
    text-align: center;
  }
}

@media (min-width: 512px) {
  .mf-proactive-case-closure ux-radio-button {
    width: 40%;
  }
}

.mf-proactive-case-closure__button-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 900px;
  margin: 0 auto;
}

@media (min-width: 512px) {
  .mf-proactive-case-closure__button-container {
    margin-top: 40px;
    justify-content: space-between;
    flex-direction: row;
  }
}
